import { render, staticRenderFns } from "./JikuFlooring.vue?vue&type=template&id=64e5a052&scoped=true&"
import script from "./JikuFlooring.vue?vue&type=script&lang=js&"
export * from "./JikuFlooring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5a052",
  null
  
)

export default component.exports